// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // DialogContentText,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Checkbox,
  Button,
  Table,
  TableRow,
  TableCell,
  Divider,
  // Divider,
  // FormControlLabel,
  // Switch,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

import Editor from "react-simple-wysiwyg";
import { useAuthUser } from "react-auth-kit";

function Campaigns() {
  const pageTitle = "Campaigns";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const auth = useAuthUser();
  const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [openNewCheckDialog, setOpenNewCheckDialog] = useState(false);
  const [openCampaignTypeDialog, setOpenCampaignTypeDialog] = useState(false);
  const [openUploadVoucherDialog, setOpenUploadVoucherDialog] = useState(false);

  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [campaigns, setCampaigns] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [dispenseCount, setDispenseCount] = useState(1);
  const [paymentRequired, setPaymentRequired] = useState(false);
  const [shippingRequired, setShippingRequired] = useState(false);
  // const [isPublic, setIsPublic] = useState(false);
  // const [voucherPrice, setVoucherPrice] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // const [agentCommission, setAgentCommission] = useState(0);
  const [customerUniqueness, setCustomerUniqueness] = useState(null);
  const [feeBearer, setFeeBearer] = useState("MERCHANT");
  const [campaignType, setCampaignType] = useState(null);

  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const [campaignPackages, setCampaignPackages] = useState([]);
  const [openPackagesDialog, setOpenPackagesDialog] = useState(false);

  const [campaignMeta, setCampaignMeta] = useState({});

  const tableColumns = [
    { Header: "#", accessor: "actions", align: "left" },
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Type", accessor: "type", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Added On", accessor: "created", align: "right" },
  ];

  function getInsightsPageUrl(campaign) {
    let url = `/campaigns/${campaign.reference}`;
    if (campaign.type === "DATA") {
      url = `/data-captures/overview/${campaign.reference}`;
    }

    if (campaign.type === "DAW") {
      url = `/campaigns/display-win/leaderboard/${campaign.reference}`;
    }

    if (campaign.type === "PSA") {
      url = `/campaigns/product-sampling/insights/${campaign.reference}`;
    }

    return url;
  }

  const buildRateRows = (data) => {
    const rows = [];
    data.map((campaign) => {
      let statusColor = "warning";
      if (campaign.status) {
        statusColor = "success";
      } else {
        statusColor = "error";
      }

      rows.push({
        title: campaign.title,
        type: campaign.type,
        status: (
          <MDBox>
            <Icon color={statusColor}>{campaign.status ? "check_circle" : "cancel"}</Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Insights">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                circular
                onClick={() => {
                  navigate(getInsightsPageUrl(campaign));
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  bar_chart
                </Icon>
              </MDButton>
            </Tooltip>
            {["DATA", "SALES"].includes(campaign.type) && (
              <>
                &nbsp;&nbsp;
                <Tooltip title={campaign.type !== "DATA" ? "Sales" : "Records"}>
                  <MDButton
                    size="small"
                    variant="outlined"
                    color="success"
                    iconOnly
                    circular
                    onClick={() => {
                      let url = `/campaigns/${campaign.reference}/sales`;
                      if (campaign.type === "DATA") {
                        url = `/data-captures/${campaign.reference}`;
                      }
                      navigate(url);
                    }}
                  >
                    <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                      list
                    </Icon>
                  </MDButton>
                </Tooltip>
              </>
            )}
            &nbsp;&nbsp;
            <Tooltip title="Manage">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                circular
                onClick={() => {
                  let url = `/campaigns/${campaign.reference}/settings`;
                  if (campaign.type === "DAW") {
                    url = `/campaigns/display-win/${campaign.reference}`;
                  }
                  if (campaign.type === "PSA") {
                    url = `/campaigns/product-sampling/${campaign.reference}`;
                  }
                  navigate(url);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  settings
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        created: campaign.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("portal/campaigns.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRateRows(result.data.data.campaigns);
            setCampaigns(rows);
            setCampaignList(result.data.data.campaigns);
            setCampaignPackages(result.data.data.packages);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createCampaign() {
    if (campaignType === null) {
      setSeverity("error");
      setErrMsg("Campaign type is required.");
      setOpen(true);
      return;
    }

    if (title === null) {
      setSeverity("error");
      setErrMsg("Campaign title is required.");
      setOpen(true);
      return;
    }

    if (description === null) {
      setSeverity("error");
      setErrMsg("Campaign description is required.");
      setOpen(true);
      return;
    }

    if (campaignType === "SALES") {
      if (customerUniqueness === null) {
        setSeverity("error");
        setErrMsg("Customer uniqueness required");
        setOpen(true);
        return;
      }

      if (paymentRequired !== null) {
        if (feeBearer === null) {
          setSeverity("error");
          setErrMsg("Fee bearer is required.");
          setOpen(true);
          return;
        }
      }
    }

    if (customerUniqueness === null) {
      setCustomerUniqueness("OPEN");
    }

    if (dispenseCount < 1) {
      setDispenseCount(1);
    }

    if (!["SALES", "DATA"].includes(campaignType)) {
      if (Object.entries(campaignMeta).length === 0) {
        setSeverity("error");
        setErrMsg("Please fill out the form properly.");
        setOpen(true);
        return;
      }
    }

    // if (endDate === null) {
    //   setSeverity("error");
    //   setErrMsg("Campaign end required");
    //   setOpen(true);
    //   return;
    // }

    setOpenNewCheckDialog(false);
    setShowLoading(true);
    const json = {
      title: `${title}`,
      description: `${description}`,
      dispense_count: parseInt(dispenseCount, 10),
      payment_required: paymentRequired,
      fee_bearer: feeBearer,
      is_shipping_required: shippingRequired,
      voucher_price: 0,
      agent_commission: 0,
      unique_customer: customerUniqueness,
      end_date: endDate,
      campaign_type: campaignType,
      meta: campaignMeta,
    };

    await axios
      .post("portal/campaigns/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg("Campaign created!");
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function postData(formData) {
    setShowLoading(true);
    await axios
      .post("portal/campaigns/vouchers/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg("Upload successful.");
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const uploadVouchers = () => {
    if (!uploadFile) {
      return;
    }
    if (!selectedCampaign) {
      return;
    }
    const formData = new FormData();
    formData.append("campaign", selectedCampaign);
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadVoucherDialog(false);
    setShowLoading(true);

    postData(formData);
  };

  function fileSelected(e) {
    e.persist();
    const fileTypes = ["xlsx", "xls", "csv"];
    const file = e.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.indexOf(extension) > -1;
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only excel and csv files accepted.");
      setOpen(true);
      return;
    }
    setUploadFile(e.target.files[0]);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openPackagesDialog} fullWidth maxWidth="lg">
        <DialogTitle>
          <MDBox align="center" mb={3}>
            Campaign Plans
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <Grid container spacing={3}>
              {campaignPackages.map((pckg) => (
                <Grid item xs={12} md={3} lg={3}>
                  <Card>
                    <MDBox p={0}>
                      <MDBox align="center" mt={1}>
                        <MDTypography variant="h6">{pckg.title}</MDTypography>
                        <MDTypography fontSize={14}>{`${accountInfo.account.currency}${(
                          pckg.price / 100
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}</MDTypography>
                        <MDTypography fontSize={12}>{pckg.duration} days</MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <Table>
                          <TableRow>
                            <TableCell>
                              <MDTypography>
                                <MDTypography fontSize={12}>Capped At</MDTypography>
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {pckg.sales_cap.toLocaleString("en", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Sales Overage</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {pckg.is_sales_fee_percentage
                                  ? `${(pckg.sales_fee * 100).toFixed(2)}%`
                                  : `${accountInfo.account.currency}${(
                                      pckg.sales_fee / 100
                                    ).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          {pckg.is_sales_fee_percentage && (
                            <>
                              {pckg.sales_fee_min && (
                                <TableRow>
                                  <TableCell>
                                    <MDTypography fontSize={12}>Fee (min)</MDTypography>
                                  </TableCell>
                                  <TableCell>
                                    <MDTypography align="right" fontSize={12}>{`${
                                      accountInfo.account.currency
                                    }${(pckg.sales_fee_min / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}</MDTypography>
                                  </TableCell>
                                </TableRow>
                              )}

                              {pckg.sales_fee_max && (
                                <TableRow>
                                  <TableCell>
                                    <MDTypography fontSize={12}>Fee (max)</MDTypography>
                                  </TableCell>
                                  <TableCell>
                                    <MDTypography align="right" fontSize={12}>{`${
                                      accountInfo.account.currency
                                    }${(pckg.sales_fee_max / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}</MDTypography>
                                  </TableCell>
                                </TableRow>
                              )}
                            </>
                          )}
                        </Table>
                      </MDBox>
                      <MDBox mt={3}>
                        <Table>
                          {/* <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Data Capture Cap</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {pckg.data_cap.toLocaleString("en", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </MDTypography>
                            </TableCell>
                          </TableRow> */}
                          <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Data Overage</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>{`${
                                accountInfo.account.currency
                              }${(pckg.data_fee / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}</MDTypography>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              ))}
            </Grid>
            <MDBox mt={3}>
              <Alert severity="info">
                <MDTypography variant="h6" fontSize={12}>
                  Overages apply only when plan cap is exceeded.
                </MDTypography>
              </Alert>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenPackagesDialog(false);
            }}
            color="dark"
            variant="outlined"
            iconOnly
            circular
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openCampaignTypeDialog} fullWidth maxWidth="md">
        <DialogTitle>
          <MDBox align="center">Select Campaign Type</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox m={0}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card elevation={5}>
                    <MDBox p={3} align="center">
                      <MDBox>
                        <MDTypography variant="h6" fontSize={24}>
                          Sales
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <MDTypography variant="body2" fontSize={14}>
                          Carry out field-sales of your products/services. Capture customer details
                          and collect payment easily.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={4}>
                        <MDButton
                          variant="contained"
                          color="success"
                          onClick={() => {
                            setCampaignMeta({});
                            setCampaignType("SALES");
                            setOpenCampaignTypeDialog(false);
                            setOpenNewCheckDialog(true);
                          }}
                        >
                          Select
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card elevation={5}>
                    <MDBox p={3} align="center">
                      <MDBox>
                        <MDTypography variant="h6" fontSize={24}>
                          Data
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <MDTypography variant="body2" fontSize={14}>
                          Ideal for data collections such as enumerations, surveys, user
                          onboardings, sales reports and other data use cases.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={4}>
                        <MDButton
                          variant="contained"
                          color="info"
                          onClick={() => {
                            setCampaignMeta({});
                            setCampaignType("DATA");
                            setOpenCampaignTypeDialog(false);
                            setOpenNewCheckDialog(true);
                          }}
                        >
                          Select
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox>
                  <Card elevation={5}>
                    <MDBox p={3} align="center">
                      <MDBox>
                        <MDTypography variant="h6" fontSize={16}>
                          Display & Win
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <MDTypography variant="body2" fontSize={14}>
                          Product display and win activations.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={4}>
                        <MDButton
                          variant="contained"
                          size="small"
                          color="dark"
                          onClick={() => {
                            setCampaignMeta({});
                            setCampaignType("DAW");
                            setOpenCampaignTypeDialog(false);
                            setOpenNewCheckDialog(true);
                          }}
                        >
                          Select
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox>
                  <Card elevation={5}>
                    <MDBox p={3} align="center">
                      <MDBox>
                        <MDTypography variant="h6" fontSize={16}>
                          Product Sampling
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <MDTypography variant="body2" fontSize={14}>
                          Sample products and collect verified feedback.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={4}>
                        <MDButton
                          variant="contained"
                          size="small"
                          color="dark"
                          onClick={() => {
                            setCampaignType("PSA");
                            setCampaignMeta({});
                            setOpenCampaignTypeDialog(false);
                            setOpenNewCheckDialog(true);
                          }}
                        >
                          Select
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCampaignTypeDialog(false);
            }}
            color="dark"
            variant="outlined"
            iconOnly
            circular
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openNewCheckDialog}>
        <DialogTitle>
          <MDBox>New Campaign ({campaignType})</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={0}>
              <MDInput
                placeholder="E.g Chicken Republic Deal"
                name="title"
                margin="dense"
                label="Campaign Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <Editor
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter a meaningful description..."
              />
            </MDBox>

            {campaignType === "SALES" && (
              <>
                <MDBox mt={3}>
                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                    <InputLabel>Customer Uniqueness</InputLabel>
                    <Select
                      label="Customer Uniqueness"
                      onChange={(e) => {
                        setCustomerUniqueness(e.target.value);
                      }}
                      sx={{ padding: "12px", paddingLeft: "3px" }}
                    >
                      <MenuItem value="CAMPAIGN">Unique to Campaign</MenuItem>
                      <MenuItem value="ACCOUNT">Unique to Account</MenuItem>
                      <MenuItem value="OPEN">Open to Anyone</MenuItem>
                    </Select>
                  </FormControl>
                </MDBox>

                <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
                  <Checkbox
                    checked={paymentRequired}
                    onChange={(e) => {
                      setPaymentRequired(e.target.checked);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Payment Required?
                  </MDTypography>
                </MDBox>
                {paymentRequired && (
                  <MDBox mt={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Fee Bearer</InputLabel>
                      <Select
                        label="Fee Bearer"
                        onChange={(e) => {
                          setFeeBearer(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        <MenuItem value="MERCHANT">Merchant (You)</MenuItem>
                        <MenuItem value="PAYER">Payer (Customer)</MenuItem>
                      </Select>
                    </FormControl>
                  </MDBox>
                )}
                <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
                  <Checkbox
                    checked={shippingRequired}
                    onChange={(e) => {
                      setShippingRequired(e.target.checked);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Shipping Required?
                  </MDTypography>
                </MDBox>
              </>
            )}
            {campaignType === "DAW" && (
              <MDBox mt={3}>
                <Divider />
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDInput
                      name="endDate"
                      margin="dense"
                      label="Start Date (optional)"
                      type="date"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => {
                        let tmpMeta = campaignMeta;
                        tmpMeta["start_date"] = e.target.value;
                        setCampaignMeta(tmpMeta);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDInput
                      name="endDate"
                      margin="dense"
                      label="End Date (optional)"
                      type="date"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => {
                        let tmpMeta = campaignMeta;
                        tmpMeta["end_date"] = e.target.value;
                        setCampaignMeta(tmpMeta);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </MDBox>
            )}

            {campaignType === "PSA" && (
              <MDBox mt={4}>
                <Divider />
                <MDBox mt={3}>
                  <MDBox mb={2}>
                    <Alert severity="info">
                      <MDTypography fontSize={12}>
                        <b>- Instant:</b> For products that can be sampled on the spot. Feedback is
                        collected instantly.
                        <br />
                        <b>- After Use:</b> For products that need to be used first. Feedback is
                        collected after usage.
                      </MDTypography>
                    </Alert>
                  </MDBox>
                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                    <InputLabel>Feedback Type</InputLabel>
                    <Select
                      label="Feedback Type"
                      onChange={(e) => {
                        setCampaignMeta((prev) => ({
                          ...prev,
                          is_instant_feedback: e.target.value,
                        }));
                      }}
                      sx={{ padding: "12px", paddingLeft: "3px" }}
                    >
                      <MenuItem value={true}>Instant</MenuItem>
                      <MenuItem value={false}>After Use</MenuItem>
                    </Select>
                  </FormControl>
                  {campaignMeta && campaignMeta.is_instant_feedback === false && (
                    <MDBox mt={2}>
                      <MDInput
                        margin="dense"
                        label="Feedback Wait Time (days)"
                        type="number"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => {
                          let tmpMeta = campaignMeta;
                          tmpMeta["feedback_window"] = e.target.value;
                          setCampaignMeta(tmpMeta);
                        }}
                      />
                      <Alert severity="info">
                        <MDTypography fontSize={12}>
                          Number of days to wait before system prompts customer for feedback.
                        </MDTypography>
                      </Alert>
                    </MDBox>
                  )}
                </MDBox>
              </MDBox>
            )}
            {/* <MDBox mt={3}>
              <MDInput
                placeholder="End Date"
                name="endDate"
                margin="dense"
                label="End Date"
                type="date"
                fullWidth
                variant="outlined"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </MDBox> */}
            {/* {paymentRequired ? (
              <MDBox mt={3}>
                <MDInput
                  placeholder="Enter voucher price"
                  name="voucherPrice"
                  margin="dense"
                  label="Voucher Price"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={voucherPrice}
                  onChange={(e) => setVoucherPrice(e.target.value)}
                />
              </MDBox>
            ) : (
              <> </>
            )} */}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewCheckDialog(false);
              setOpenCampaignTypeDialog(true);
            }}
            color="dark"
            variant="outlined"
            startIcon={<Icon>west</Icon>}
          >
            Back
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createCampaign();
            }}
          >
            Create Campaign
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        {pageLoaded && (
          <MDBox align="right">
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={3}>
                  <MDBox align="center">
                    <MDBox mb={3}>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>workspaces</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                        Transform your field operations with <b>Laddar Campaigns</b>.
                      </MDTypography>
                      <MDBox align="center">
                        <MDTypography mt={1} variant="h6" fontWeight="light" fontSize={14}>
                          Ideal for:
                        </MDTypography>
                        <MDBox mt={2} align="center">
                          <Grid container spacing={2}>
                            <Grid item xs={6} md={2} lg={2}>
                              <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                                <MDBox p={1}>
                                  <MDTypography variant="h6" fontSize={24}>
                                    <Icon>receipt</Icon>
                                  </MDTypography>
                                  <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                                    Field Sales
                                  </MDTypography>
                                </MDBox>
                              </Card>
                            </Grid>
                            <Grid item xs={6} md={2} lg={2}>
                              <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                                <MDBox p={1}>
                                  <MDTypography variant="h6" fontSize={24}>
                                    <Icon>poll</Icon>
                                  </MDTypography>
                                  <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                                    Market Surveys
                                  </MDTypography>
                                </MDBox>
                              </Card>
                            </Grid>
                            <Grid item xs={6} md={2} lg={2}>
                              <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                                <MDBox p={1}>
                                  <MDTypography variant="h6" fontSize={24}>
                                    <Icon>checklist</Icon>
                                  </MDTypography>
                                  <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                                    Enumerations
                                  </MDTypography>
                                </MDBox>
                              </Card>
                            </Grid>
                            <Grid item xs={6} md={2} lg={2}>
                              <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                                <MDBox p={1}>
                                  <MDTypography variant="h6" fontSize={24}>
                                    <Icon>rocket</Icon>
                                  </MDTypography>
                                  <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                                    Activations
                                  </MDTypography>
                                </MDBox>
                              </Card>
                            </Grid>
                            <Grid item xs={6} md={2} lg={2}>
                              <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                                <MDBox p={1}>
                                  <MDTypography variant="h6" fontSize={24}>
                                    <Icon>people</Icon>
                                  </MDTypography>
                                  <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                                    On-boarding
                                  </MDTypography>
                                </MDBox>
                              </Card>
                            </Grid>
                            <Grid item xs={6} md={2} lg={2}>
                              <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                                <MDBox p={1}>
                                  <MDTypography variant="h6" fontSize={24}>
                                    <Icon>edit_note</Icon>
                                  </MDTypography>
                                  <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                                    Data Collections
                                  </MDTypography>
                                </MDBox>
                              </Card>
                            </Grid>
                          </Grid>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                    <MDBox mt={5} mb={3} display="flex" alignItems="center" justifyContent="center">
                      {accountInfo.account.plan.code === "PAG" && (
                        <MDButton
                          color="warning"
                          onClick={() => setOpenPackagesDialog(true)}
                          variant="outlined"
                          startIcon={<>{accountInfo.account.currency}</>}
                        >
                          View Pricing
                        </MDButton>
                      )}
                      <MDButton
                        sx={{ ml: { xs: 1 } }}
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setPaymentRequired(false);
                          setTitle(null);
                          setDescription(null);
                          setOpenCampaignTypeDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Create Campaign
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={0}>
                  <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="medium">
                      Campaigns
                    </MDTypography>
                    {/* <MDBox>
                      {accountInfo.account.plan.code === "PAG" && (
                        <MDButton
                          color="warning"
                          onClick={() => setOpenPackagesDialog(true)}
                          variant="outlined"
                          startIcon={<>{accountInfo.account.currency}</>}
                        >
                          View Pricing
                        </MDButton>
                      )}
                      &nbsp;
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setPaymentRequired(false);
                          setTitle(null);
                          setDescription(null);
                          setOpenCampaignTypeDialog(true);
                        }}
                        iconOnly
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox> */}
                  </MDBox>
                  <MDBox mt={0} mb={3}>
                    <DataTable
                      table={{ columns: tableColumns, rows: campaigns }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Campaigns;
